import * as React from 'react';
import Radium from '@flipdish/radium';
import { AppDesignScheme } from '../../Api';
import { Link } from 'react-router';
import { Translate } from 'react-localize-redux';
import { AccessibilityButton } from '../../../ui/AccessibilityButton/AccessibilityButton';
import { RadiumContainer, useRadium } from '../../hooks/useRadium';
import { useAppDesignScheme } from '../../hooks/useAppDesignScheme';

const tinycolor = require('tinycolor2');

interface LinkFieldProps {
  to?: string;
  key: string;
  dataFd?: string;
  textId: TranslationId;
  iconClassName: string;
  onClick?: () => void;
}

const LinkField = (props: LinkFieldProps) => {
  const radium = useRadium();
  const { AppDesignScheme, isDark } = useAppDesignScheme();

  const styles = {
    link: {
      ':hover': {},
      ':active': {}
    },
    default: {
      color: AppDesignScheme.Primary
    },
    hover: {
      color: AppDesignScheme.Secondary
    },
    active: {
      color: tinycolor(AppDesignScheme.Secondary)
        .darken(10)
        .toString()
    }
  };

  const content = (
    <div
      className="fd-nav flex flex-align-center menu__sidepanel__item menu__sidepanel__item--link"
      style={styles.link as any}
      key={props.key}
    >
      <i
        className={`${props.iconClassName} tertiary`}
        style={
          radium.isActive(props.key)
            ? styles.active
            : radium.isHover(props.key)
            ? styles.hover
            : isDark
            ? styles.default
            : {}
        }
        aria-hidden="true"
      />
      <p
        className="inline-block clear-margins tertiary fd-h4"
        style={
          radium.isActive(props.key)
            ? styles.active
            : radium.isHover(props.key)
            ? styles.hover
            : isDark
            ? styles.default
            : {}
        }
      >
        <u>
          <Translate id={props.textId} />
        </u>
      </p>
    </div>
  );

  return props.to ? (
    <RadiumContainer radium={radium}>
      <Link to={props.to} data-fd={props.dataFd} onClick={props.onClick}>
        {content}
      </Link>
    </RadiumContainer>
  ) : (
    <RadiumContainer radium={radium}>
      <AccessibilityButton onClick={props.onClick} dataFd={props.dataFd}>
        {content}
      </AccessibilityButton>
    </RadiumContainer>
  );
};

export default LinkField;
